import '../../styles/ManHoursDescription.css';
import { Card } from 'react-bootstrap';

const ManHoursCategoryDescription = () => {
  return (
    <Card className="mb-3 mt-1 mb-1 py-0 px-0 rounded-4 manhours-description">
      <Card.Body className="p-1 pe-0">
        <p className="m-0 small pe-2">
          工数A: 会議、打合せ、営業、納品など
          <br />
          工数B: 設計計算、技術検討、CG構成、絵コンテ、プログラム開発など
          <br />
          工数C: 図面作成、CG作成、CG編集作業など
          <br />
          工数D: 積算業務、CGコンポジット・動画編集
          <br />
          工数E: その他これ等の分類以外
        </p>
      </Card.Body>
    </Card>
  );
};

export default ManHoursCategoryDescription;
